import styled from 'styled-components';
import { palette } from 'styled-tools';

export const GradientBackground = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;

	background: ${palette('gradientTabBlue')};
`;
